import type { PromiseResult } from '@vaaas/fpts/promise-result';
import { load_script } from '@phi/util/dom';
import { map } from '@vaaas/fpts/result';
import { DataLayer } from './datalayer';

let loaded = false;

export function initialise(tag: string): PromiseResult<DataLayer> {
    if (loaded)
        // @ts-ignore
        return Promise.resolve(window.dataLayer);

    // @ts-ignore
    window.dataLayer = window.dataLayer || [];
    // @ts-ignore
    window.dataLayer.push({
        event: 'gtm.js',
        'gtm.start': new Date().getTime(),
    });

    //console.log('Initialising tag manager for ID: ' + tag);
    return load_script(`https://www.googletagmanager.com/gtm.js?id=${tag}`)
        .then(map(() => {
            loaded = true;
            // @ts-ignore
            return window.dataLayer;
        }));
}
